import RequestPayload from "slotworks/model/gameplay/requests/request-payload";

export default class InitRequestPayload extends RequestPayload {
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/model/gameplay/requests/init-request-payload.ts